// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2R4tY","footer":"ChangeClinic_footer__vayPj"};